// crewbit-admin/src/hooks/useDeriveQuickMethodConfig.ts
//
// Tier 2 Phase C §WorldClass.2 — Quick Method auto-derive substrate.
// Admin paired hook for derive_quick_method_config RPC (Migration 274).
// Mirrors crewbit-mobile/hooks/useDeriveQuickMethodConfig.ts.
//
// Read-only RPC; no event emit. Mutation happens via useUpdateBusinessMoneySettings
// when operator confirms QM election with derived or override rate.

import { useCallback } from 'react';
import { callMoneyRpc, type MoneyRpcResult } from '../lib/moneyRpc';
import type { DeriveQuickMethodConfigSuccess } from '../types/quickMethod';

export interface DeriveQuickMethodConfigArgs {
  businessId: string;
}

export type DeriveQuickMethodConfigHookResult = MoneyRpcResult<
  Omit<DeriveQuickMethodConfigSuccess, 'success'>
>;

export function useDeriveQuickMethodConfig() {
  return useCallback(
    async (args: DeriveQuickMethodConfigArgs): Promise<DeriveQuickMethodConfigHookResult> => {
      return callMoneyRpc<Omit<DeriveQuickMethodConfigSuccess, 'success'>>(
        'derive_quick_method_config',
        { p_business_id: args.businessId },
      );
    },
    [],
  );
}
